<template>
<div>
    <div class="flex flex-row items-center justify-between py-4 px-8">
        <div>
            <div class="page-header tenant-main-color">
                Learner Dashboard
            </div>
            <p class="page-sub">
                Welcome. Here are the things you can do. You can always find them on
                the sidebar on the left.
            </p>
        </div>
        <div>
            <img class="h-24 md:mr-4" :src="require('../../assets/tenant_dashboard.png')" alt="" />
        </div>
    </div>

    <div class="flex flex-wrap mx-6 ">
        <l-dashboard-card v-for="(card, i) in cards" :key="i" :card="card" class="flex" />
    </div>
</div>
</template>

<script>
import {
    mapActions
} from "vuex";
export default {
    components: {
        LDashboardCard: () => import("@/components/learner/dashboard-card"),
    },
    data() {
        return {
            cname: "",
            form: {},
            user: this.$store.state.auth.user,
            error: {},
            search: "",
            cards: [
                // {
                //   title: "User Management",
                //   description: "Manage all your Users and Learners",
                //   image: "https://res.cloudinary.com/dldd8ucby/image/upload/v1590854501/LMS/course.png",
                // },
                // {
                //     title: "Program",
                //     description: "View All Available Programs",
                //     image: "https://res.cloudinary.com/dldd8ucby/image/upload/v1590854501/LMS/program.png",
                //     route: "learner-programs",
                // },
                {
                    title: "My Courses",
                    description: "View Available Courses and enroll to the individual courses",
                    image: "https://res.cloudinary.com/dldd8ucby/image/upload/v1590854501/LMS/course.png",
                    route: "learner-enrolled-courses",
                },
                // {
                //     title: "To Do Lists",
                //     description: "Create and Manage To Do Lists",
                //     image: "https://res.cloudinary.com/sla-sheleadsafrica/image/upload/v1595370268/assets/todo_hnkzzq.png",
                //     route: "learner-todo-home",
                // },
            ],
        };
    },
    methods: {
        ...mapActions(["fetchAdminRoles", "fetchSingleTenant"]),
    },
    async mounted() {
        let user = await this.fetchSingleTenant({
            id: this.user.id,
        });

        this.cname = user.company_name;
        // //console.log(user)
        // this.fetchAdminRoles();
    },
};
</script>

<style scoped>
.page-header {
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 42px;
    letter-spacing: 0.11px;
}

.page-sub {
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.11px;

    color: #043f6c;
}
</style>
